import * as types from "./types";
import * as selectors from "./selectors";
import chameleonjs from "chameleonjs";

export const brandUpdated = brand => ({
  type: types.BRAND_UPDATED,
  brand
});

const fetchBrandRequest = brandKey => ({
  type: types.FETCH_BRAND_REQUEST,
  brandKey
});
const fetchBrandSuccess = (brandKey, data) => ({
  type: types.FETCH_BRAND_SUCCESS,
  brandKey,
  data
});
const fetchBrandFailure = (brandKey, error, fallbackBrand) => ({
  type: types.FETCH_BRAND_FAILURE,
  brandKey,
  error,
  fallbackBrand
});

const shouldFetchBrand = (state, brandKey) =>
  !selectors.isBrandFetching(state) &&
  selectors.getBrandKey(state) !== brandKey;

export const fetchBrand = brandKey => async (dispatch, getState) => {
  const state = getState();
  if (shouldFetchBrand(state, brandKey)) {
    dispatch(fetchBrandRequest(brandKey));
    return chameleonjs
      .loadBrand(brandKey, "fraction")
      .then(data => {
        dispatch(fetchBrandSuccess(brandKey, data));
      })
      .catch(error => {
        dispatch(fetchBrandFailure(brandKey, error, {}));
      });
  }
};
